import React from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import '../components/sidebar.css';
import safrelog from '../safreeimg/safreelogo.png';
import hdrman from '../safreeimg/man.png';
import dashbo from '../safreeimg/superadminimg/dash.png';
import user from '../safreeimg/superadminimg/user.png';
import Organisation from '../safreeimg/superadminimg/orgtion.png';
import Support from '../safreeimg/superadminimg/supportticket.png';
import Alarm from '../safreeimg/superadminimg/alrm.png';
import manual from '../safreeimg/superadminimg/manualnoti.png';
import logout from '../safreeimg/superadminimg/logout.png';
import subscritn from '../safreeimg/superadminimg/Subscription.png';
import coupon from '../safreeimg/superadminimg/coupon.png';
// pageslink.. 
import Admin1Page1 from '../components/Admin1/Pages/Page1';
import UserManagement from '../components/Admin1/Pages/userManagement';
import OrganisationManagement from '../components/Admin1/Pages/organisationManagement';
import UsermyGuardians from '../components/Admin1/Pages/usermyGuardians';
import OrgMemberDetails from '../components/Admin1/Pages/orgMemberDetails';
import OrganizationGroup from '../components/Admin1/Pages/organizationGroups';
import AlarmManagement from '../components/Admin1/Pages/alarmManagement'
import UserimGuardians from '../components/Admin1/Pages/userImGuarding';
import OrganisationMember from '../components/Admin1/Pages/organizationMember';
import ManualNotifications from '../components/Admin1/Pages/manualNotifications';
import SupportTicket from '../components/Admin1/Pages/supportTicket';
import OrgGroupViewDetails from '../components/Admin1/Pages/orgGroupViewDetail';
import OrgSubGroupDetails from '../components/Admin1/Pages/orgSubGroupDetails';
import OrgSubGroupViewDetail from '../components/Admin1/Pages/orgSubGroupViewdetail';
import SubscriptionManag from './Admin1/Pages/subscriptionManagement';
import TrackPayment from './Admin1/Pages/trackPayments';
import CouponDiscount from './Admin1/Pages/coupon&Discount';
import NewCoupon from './Admin1/Pages/createNewCoupon';
import CouponSend from './Admin1/Pages/couponSend';
import CouponDiscountOrg from './Admin1/Pages/coupon&DisountOrg';
import CouponSendOrg from './Admin1/Pages/couponSendOrg';

// pageslink.. 

const Admin1Sidebar = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="app-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <ul>
          <NavLink
            to="/admin1/dashboard"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={dashbo} alt="Dashboard Icon" />
              </span>
              Dashboard
            </li>
          </NavLink>
          <NavLink
            to="/admin1/user-Management"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={user} alt="User Management Icon" />
              </span>
              User Management
            </li>
          </NavLink>
          <NavLink
            to="/admin1/organisation-Management"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Organisation} alt="Organisation Icon" />
              </span>
              Organization Management
            </li>
          </NavLink>

          <NavLink
            to="/admin1/alarmManagement"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Alarm} alt="Alarm Management Icon" />
              </span>
              Alarm Management
            </li>
          </NavLink>

          <NavLink
            to="/admin1/subscriptionManag"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={subscritn} alt="Subscription Management Icon" />
              </span>
              Subscription Management
            </li>
          </NavLink>
          <NavLink
            to="/admin1/couponDiscount"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={coupon} alt="Coupon & Discount Icon" />
              </span>
              Coupon & Discount
            </li>
          </NavLink>
          <NavLink
            to="/admin1/manualNotifications"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={manual} alt="Manual Notification Icon" />
              </span>
              Manual Notification
            </li>
          </NavLink>
          <NavLink
            to="/admin1/supportTicket"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Support} alt="Support Ticket Icon" />
              </span>
              Support Ticket
            </li>
          </NavLink>
          {/* Logout Button */}
          <li className="sidebar-item sidebar-items sidebar-link" onClick={handleLogout}>
            <span className="icon">
              <img src={logout} alt="Logout Icon" />
            </span>
            Logout
          </li>
        </ul>
        <ul className='sidpriv'>
          <a href="https://safree.org/Terms&Conditions.html" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
          <a href="https://safree.org/privacy.html" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </ul>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="app-header">
          <div className="logo">
            <img src={safrelog} alt="Logo" />
          </div>
        </header>
        <div className="content">
          {children}
          <Routes>
            <Route path="dashboard" element={<Admin1Page1 />} />
            <Route path="user-Management" element={<UserManagement />} />
            <Route path="organisation-Management" element={<OrganisationManagement />} />
            <Route path="/user-Management/usermyGuardians" element={<UsermyGuardians />} />
            <Route path="orgMemberDetails" element={<OrgMemberDetails />} />
            <Route path="/organisation-Management/organizationGroup" element={<OrganizationGroup />} />
            <Route path="alarmManagement" element={<AlarmManagement />} />
            <Route path="/user-Management/userimGuardians" element={<UserimGuardians />} />
            <Route path="/organisation-Management/organisationMember" element={<OrganisationMember />} />
            <Route path="manualNotifications" element={<ManualNotifications />} />
            <Route path="supportTicket" element={<SupportTicket />} />
            <Route path="/organisation-Management/organizationGroup/orgGroupViewDetails" element={<OrgGroupViewDetails />} />
            <Route path="/organisation-Management/organizationGroup/orgSubGroupDetails" element={<OrgSubGroupDetails />} />
            <Route path="/organisation-Management/organizationGroup/orgSubGroupDetails/orgSubGroupViewDetail" element={<OrgSubGroupViewDetail />} />
            <Route path="subscriptionManag" element={<SubscriptionManag />} />
            <Route path="trackPayment" element={<TrackPayment />} />
            <Route path="couponDiscount" element={<CouponDiscount />} />
            <Route path="/couponDiscount/newCoupon" element={<NewCoupon />} />
            <Route path="/couponDiscount/couponSend" element={<CouponSend />} />
            <Route path="/organisation-Management/CouponDiscountOrg" element={<CouponDiscountOrg />} />
            <Route path="/organisation-Management/CouponDiscountOrg/couponSendOrg" element={<CouponSendOrg />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Admin1Sidebar;
